import gql from "graphql-tag";

export const GETINVENTORY = gql`
  query getInventories(
    $Column: String
    $Search: String
    $Dept_ID: [String]
    $Page_No: Int
    $Page_Size: Int
  ) {
    getInventories(
      Column: $Column
      Search: $Search
      Dept_ID: $Dept_ID
      Page_No: $Page_No
      Page_Size: $Page_Size
    ) {
      ItemNum
      ItemName
      Company
      Dept_ID
    }
  }
`;

export const GETINVENTORYFORTAG = gql`
  query getInventory($ItemNum: String!, $CustNum: String!) {
    getInventory(ItemNum: $ItemNum, CustNum: $CustNum) {
      ItemNum
      ItemName
      Store_ID
      Cost
      Price
      ChargedPrice
      ItemName_Extra
      Vendor_Part_Num
      Company
      Dept_ID
      Description
      In_Stock
    }
  }
`;

export const GETINVENTORYLENGTH = gql`
  query getInventoriesLength(
    $Column: String
    $Search: String
    $Dept_ID: [String]
  ) {
    getInventoriesLength(Column: $Column, Search: $Search, Dept_ID: $Dept_ID) {
      Length
    }
  }
`;

export const CHECKITEMANDCRV = gql`
  query checkItemAndCRV($ItemNum: String!) {
    checkItemAndCRV(ItemNum: $ItemNum) {
      ItemType
      TagItemNum
    }
  }
`;

export const GETINVOICE = gql`
  query getInvoices(
    $column: String
    $search: String
    $status: String
    $date: String
    $startDate: String
    $endDate: String
    $page_No: Int
    $page_Size: Int
    $IsLike: Boolean
  ) {
    getInvoices(
      Condition: {
        Column: $column
        Date: $date
        Search: $search
        Status: $status
        StartDate: $startDate
        EndDate: $endDate
        IsLike: $IsLike
      }
      Page_No: $page_No
      Page_Size: $page_Size
    ) {
      CustNum
      First_Name
      Last_Name
      Company
      Address_1
      Address_2
      City
      Zip_Code
      Phone_1
      Phone_2
      Total_Price
      Grand_Total
      Cashier_ID
      Status
      Invoice_Number {
        Invoice_Number
        In_Stock
        LineNum
        ItemNum
        ItemName
        ItemName_Extra
        Vendor_Part_Num
        Quantity
        CostPer
        ChargedPrice
        PricePer
        Total
      }
      DateTime
    }
  }
`;

export const GETINVOICELENGTH = gql`
  query getInvoicesLength(
    $column: String
    $search: String
    $status: String
    $date: String
    $startDate: String
    $endDate: String
    $IsLike: Boolean
  ) {
    getInvoicesLength(
      Condition: {
        Column: $column
        Search: $search
        Status: $status
        Date: $date
        StartDate: $startDate
        EndDate: $endDate
        IsLike: $IsLike
      }
    ) {
      Length
    }
  }
`;

export const GETDEPARTMENT = gql`
  query getDepartments {
    getDepartments {
      Dept_ID
      Store_ID
      Description
    }
  }
`;

export const GETSHORTAGE = gql`
  query getShortages($Page_No: Int, $Page_Size: Int) {
    getShortages(Page_No: $Page_No, Page_Size: $Page_Size) {
      ItemNum
      ItemName
      ItemName_Extra
      Vendor_Number
      Company
      Dept_ID
      Description
      Ordered
      Available
      Required
      State
    }
  }
`;

export const GETSHORTAGELENGTH = gql`
  query getShortagesLength {
    getShortagesLength {
      Length
    }
  }
`;

export const GETTEMPLATE = gql`
  query getTemplates($CustNum: String) {
    getTemplates(CustNum: $CustNum) {
      _id
      Cost
      CustNum
      Dept_ID
      Description
      In_Stock
      ChargedPrice
      ItemNum
      ItemName
      ItemName_Extra
      Price
      Quantity
      Store_ID
      Vendor_Part_Num
      Company
      CreateDate
      UpdateDate
    }
  }
`;

export const GETDASHBOARD = gql`
  query getDashboard(
    $StartDate: String
    $EndDate: String
    $Format: String
    $ItemNum: String
    $Dept_ID: String
    $CustNum: String
    $GroupBy: String
  ) {
    getDashboard(
      StartDate: $StartDate
      EndDate: $EndDate
      Format: $Format
      ItemNum: $ItemNum
      Dept_ID: $Dept_ID
      CustNum: $CustNum
      GroupBy: $GroupBy
    ) {
      Cost
      Price
      Profit
      DATE
      PFPercent
    }
  }
`;

export const GETLATESTPRICE = gql`
  query getLatestPrice($ItemNum: String!) {
    getLatestPrice(ItemNum: $ItemNum) {
      ItemNum
      Company
      CustNum
      CostPer
      Quantity
      PricePer
      DateTime
    }
  }
`;
